// extracted by mini-css-extract-plugin
module.exports = {"video":"screenCapture_video__UO1a-","boxArea":"screenCapture_boxArea__1ImTf"};